export default {"src":"/_next/static/media/gamedev.cfc5edd4.svg","height":28,"width":143};